import { render, staticRenderFns } from "./VMoeda.vue?vue&type=template&id=5d560910&"
import script from "./VMoeda.vue?vue&type=script&lang=js&"
export * from "./VMoeda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports